//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

import { chunk } from 'underscore'

export default {
  props: {
    block: {}
  },

  computed: {
    events: function() {
      return this.block.events
    },
    paginatedEvents: function() {
      return this.pages[this.page]
    }
  },
  watch: {

  },
  components: {

  },
  filters: {

  },
  data() {
    return { 
      
      loading: true,
      page: 0,
      total_pages: 1,
      pages: [],
      per_page: 3,
      included: false,

      containerClass: 'featured-events--block',
      activeEvent: null
     
    }
  },
  mounted() {

    let self = this;

    let pages = chunk( this.block.events, this.per_page );
    this.total_pages = pages.length
    this.pages = pages


    console.log('PAGES', pages)

  },
  methods: {
    nextPage() {
      if ( this.page < this.total_pages - 1 ) {
        this.page++;
      } else {
       // this.page = 0;
      }
    },
    prevPage() {
      if ( this.page > 0 ) {
        this.page--;
      } else {
      //  this.page = this.total_pages - 1;
      }
    },
    setActiveEvent(event) {
      this.activeEvent = event;
    },
    checkTarget(e, href) {
      if (this.page == 'events') {
        e.preventDefault(0);
        console.log('this is working', href);
        window.location.href = href;
        window.location.reload();
      }
    },
    getUpload(event) {
      if (event.thumbnail && event.thumbnail.length > 0) {
        return event.thumbnail.replace('_t.', '_o.');
      } else {
        return false;
      }
    },
    printDate(dt, ps, fm) {
      return format( parse(dt, ps, new Date()), fm );
    },
  }
}




// WEBPACK FOOTER //
// ./scripts/components/KitBlocks/KitEvents.vue